/*
 * <marketplace-strip>: the PDP "Shop with confidence" trust strip. Its only job is
 * to publish each outbound marketplace click as a Shopify custom pixel event
 * (`siyou_marketplace_outbound_click`) that a custom pixel in Settings > Customer
 * events forwards to GA4. The link itself is never intercepted: it opens in a new
 * tab, so the page and the pixel sandbox survive the click and no beacon is needed.
 */
if (!customElements.get("marketplace-strip")) {
  customElements.define(
    "marketplace-strip",
    class MarketplaceStrip extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener("click", this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener("click", this.onClick);
      }

      onClick(event) {
        const link = event.target.closest("a[data-marketplace]");
        if (!link || !this.contains(link)) return;
        let variantId = null;
        try {
          variantId = new URL(window.location.href).searchParams.get("variant");
        } catch (e) {
          variantId = null;
        }
        const payload = {
          marketplace: link.dataset.marketplace,
          url: link.href,
          product_id: this.dataset.productId || null,
          product_handle: this.dataset.productHandle || null,
          variant_id: variantId,
        };
        try {
          const analytics = window.Shopify && window.Shopify.analytics;
          if (analytics && typeof analytics.publish === "function") {
            analytics.publish("siyou_marketplace_outbound_click", payload);
          }
        } catch (e) {
          // Analytics must never block the outbound navigation.
        }
      }
    }
  );
}
